// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"881":"cd841a1c","906":"4470f7c1"}[chunkId] + ".css";
};